<template lang="pug">
  b-modal(
    v-model="value_"
    modal-class="channex-sync-main"
    centered
    hide-header
    hide-footer
    no-close-on-esc
  )
    h6.text-left.font-weight-bold Units
    hr.mt-1
    b-row.no-gutters
      b-col(sm="12")
        b-btn(block variant="outline-secondary" disabled) Import Room Types from Channex

      b-col.mt-3(sm="12")
        b-btn(block variant="outline-secondary" @click="$emit('sync-units')") Send Units to Channex

    h6.text-left.font-weight-bold.mt-5 Rates
    hr.mt-1
    b-row.no-gutters
      b-col(sm="12")
        b-btn(block variant="outline-secondary" @click="$emit('sync-rates')") Send Rates to Channex

    h6.text-left.font-weight-bold.mt-5 Bookings
    hr.mt-1
    b-row.no-gutters
      b-col(sm="12")
        b-btn(block variant="outline-secondary" @click="$emit('import-bookings')") Import Bookings from Channex

      b-col.mt-3(sm="12")
        b-btn(block variant="outline-secondary" @click="$emit('sync-avr')") Send Availability to Channex

    b-row.no-gutters.mt-3
      b-col.text-right(sm="12")
        b-btn(variant="secondary" @click="onClose") Close

</template>

<script>
export default {
  name: 'SyncMainModal',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    value_: {
      get () {
        return this.value;
      },

      set (v) {
        this.$emit('input', v);
      }
    },
  },

  methods: {
    onClose() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.channex-sync-main {
  .modal-dialog {
    max-width: 650px;
  }

  .modal-content {
    padding: 10px
  }
}
</style>
